import getResetPasswordUrl from "core/api/getResetPasswordUrlApi/getResetPasswordUrlApi";

const RESET_PASSWORD_URL = process.env.REACT_APP_RESET_PASSWORD_URL;

export const getResetPasswordFallbackModal = (
  errorCode = "USER_DATA_NOT_FOUND"
) => ({
  errorCode,
  warning: {
    id: "dados-usuario-nao-encontrados",
    title: "Não foi possível alterar a senha",
    message:
      "Não encontramos os dados necessários para continuar. Clique no botão abaixo para redefinir sua senha.",
    buttons: [
      {
        "data-gtm-event-action": "clique:botao:modal",
        "data-gtm-event-category": "minha-claro:meu-perfil",
        "data-gtm-event-label":
          "dados-usuario-nao-encontrados:redefinir-senha",
        label: "Redefinir senha",
        onClick: () => (window.location.href = RESET_PASSWORD_URL),
      },
    ],
  },
});

export const resetPasswordUrlRedirect = async ({ documentId = "" } = {}) => {
  const urlData = {
    cpfCnpj: documentId,
    clientid: "CREDENTIALS",
    utm_source: "area_cliente",
    utm_medium: "area_logada",
    urlRedirect: "https://minhaclaro.claro.com.br/acesso-rapido/",
  };

  const result = await getResetPasswordUrl(urlData);

  if (result?.error?.errorCode) return getResetPasswordFallbackModal(result?.error?.errorCode);

  if (typeof result === "string" && result) return window.location.href = result;

  return getResetPasswordFallbackModal();
};
